import React from "react";
import "./Image.css";

const SIZES = ["image--small", "image--medium", "image--large"];

const Image = ({
  alt,
  imageSize,
  src = "//upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/255px-Flag_of_Argentina.svg.png",
}) => {
  const checkImageSize = SIZES.includes(imageSize) ? imageSize : SIZES[1];

  return (
    <div>
      <img src={src} className={` ${checkImageSize}  `} alt={alt} />
    </div>
  );
};

export default Image;
